// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__2IlRb"};